import { Colors, Metrics, Typography } from "../../resources";
import { StyleSheet, Text, View } from "react-native";

import React from "react";
import { calculatePercentage } from "../../utils";

interface IProps {
  value: number;
  total: number;
  noColor?: boolean;
  threshhold?: number | null;
  bg?: boolean;
}

const SPercentChip: React.FC<IProps> = ({
  value,
  total,
  noColor = false,
  threshhold = null,
  bg = false,
}) => {
  let backgroundColor = Colors.grey100;
  let color = Colors.grey500;
  const percentage = calculatePercentage(value, total);
  const bar = (percentage * 64) / 100;

  let adjustedValue = percentage;
  if (threshhold != null) {
    adjustedValue = Math.floor(100 * (value / threshhold));

    if (noColor) {
      backgroundColor = Colors.grey100;
      color = Colors.grey500;
    } else if (adjustedValue < 80) {
      backgroundColor = Colors.green100;
      color = Colors.green500;
    } else if (adjustedValue >= 80 && adjustedValue < 100) {
      backgroundColor = Colors.yellow100;
      color = Colors.yellow500;
    } else if (adjustedValue >= 100) {
      backgroundColor = Colors.red100;
      color = Colors.red500;
    } else {
      backgroundColor = Colors.grey100;
      color = Colors.grey500;
    }
  } else {
    backgroundColor = Colors.grey100;
    color = Colors.grey500;
  }

  const percentageWidth = (Metrics.size64 * percentage) / 100.0;
  const barPercentageThreshhold = (Metrics.size52 * 100) / Metrics.size64;
  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: bg ? "transparent" : backgroundColor,
          borderColor: color,
        },
      ]}
    >
      {bg ? (
        <>
          <View
            style={[
              styles.bg,
              {
                width: Metrics.size64,
                backgroundColor: backgroundColor,
              },
            ]}
          />
          <View
            style={[
              styles.hideLayer,
              { width: Metrics.size64 - percentageWidth },
            ]}
          />
        </>
      ) : null}

      <View style={[styles.absoluteLayer, { borderColor: backgroundColor }]}>
        <Text style={[styles.text, { color: color }]}>{`${percentage}%`}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "flex-start",
    width: Metrics.size64,
    height: Metrics.size24,
    borderRadius: Metrics.size24 / 2,
    borderWidth: 0,
    backgroundColor: "red",
  },
  bg: {
    justifyContent: "center",
    alignItems: "flex-start",
    width: Metrics.size64,
    height: Metrics.size24,
    borderRadius: Metrics.size24 / 2,
    borderWidth: 0,
  },
  text: {
    ...Typography.bodyNumber,
    textAlign: "center",
  },
  absoluteLayer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: Metrics.size64,
    height: Metrics.size24,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderRadius: Metrics.size24 / 2,
    elevation: 2,
  },
  hideLayer: {
    position: "absolute",
    right: 0,
    top: 0,
    height: Metrics.size24,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.white,
    elevation: 1,
  },
  bar: {
    position: "absolute",
    height: Metrics.size24,
    borderBottomLeftRadius: Metrics.size24 / 2,
    borderTopLeftRadius: Metrics.size24 / 2,
    backgroundColor: "transparent",
  },
});

export default SPercentChip;
